<template>
  <div
      id="app_menu"
      class="public app_menu_container"
      :class="{ active: float_name !== '' }"

  >
    <!--    <universal_filter public="true" @treePass="treeLoad"></universal_filter>-->

    <div class="menu-effect bf-sat-blur" @click.stop="onClickMenuNav('')"></div>

    <div class="menu-content">
      <!-- menu-effect -->

      <div class="menu-nav" @click.stop="onClickMenuNav('')">
        <!-- LOGO -->
        <div class="logo">
          <div class="wrap-logo">
            <a :href="url()">
              <img
                  :src="url('/media/icons/svg/logo4-belt.svg')"
                  alt="Logo 4-Belt"
              />
            </a>
          </div>
        </div>


        <!-- HAMBURGER -->
        <div class="menu-handle" @click.stop="onClickMenuNav('submenu')">
          <div
              id="ham"
              class="menu-ham"
              :class="{ active: opened_menu_nav && float_name === 'submenu' }"
          >
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div class="menu-helper-str">
            <label class="mob-none"> {{ trans.get('public.menu.menu') }} </label>
          </div>
        </div>

        <!-- <div class="menu-search">
          <div class="elm-search"></div>
        </div> -->

        <!-- CONTATTACI -->
        <div class="menu-contact-ref">
          <a href="/contact-us">
            <div class="contact-ref">
              <img
                  class="mr-2"
                  :src="url('/media/icons/svg/contattaci.svg')"
                  alt="Contattaci"
              />
              <span class="str-helper mob-none">{{
                  trans.get("generals.contact_us")
                }}</span>
            </div>
          </a>
        </div>

        <!-- USER MENU -->
        <div
            :class="(user.loaded) ? 'user-menu': 'user-menu unlogged'">
          <div class="ricerca">
            <img src="/storage/media/icons/svg/icona-lente.svg" alt="search" @click="ricerca = !ricerca">
          </div>
          <div class="v-seselct-lang mr-5 pointer">
            <lang-selector @click="langOpen = !langOpen" v-if="!langOpen"/>
          </div>

          <div
              v-if="user.loaded"
              class="menu-login-ref d-flex align-items-center">
            <div class="role-page d-flex align-items-center">
              <a
                  class="d-flex align-items-center size-09"
                  :href="user.role !== 1 ? `${url('/b2b/personal-area')}` : ''">
                <img src="/media/icons/svg/user.svg" alt=""/>
                <span class="text-capitalize ml-3 mr-5 mob-none">
                  {{ user.name }}
                </span>
              </a>

              <a
                  class="size-09 "
                  v-if="user.role === 1"
                  :href="url('/admin')">
                {{ trans.get("generals.dashboard") }}
              </a>

              <a
                  class="size-09 d-flex align-items-center"
                  v-else-if="user.role === 2 || user.role === 3"
                  :href="url('/b2b')">
                <i class="fas fa-store"></i>
                <span class="ml-3 mr-5 mob-none">
                  {{ trans.get("generals.shop") }}
                </span>
              </a>
            </div>

            <a
                class="size-09 pointer red d-flex align-items-center ml-5"
                @click="logout()"
            >
              <img src="/media/icons/svg/logout-red.svg" alt="logout"/>
              <span class="ml-4 text">{{ trans.get('public.menu.log-out') }}</span>
            </a>
          </div>

          <div v-else class="menu-login-ref">
            <a @click="login = !login">
              <div class="login-ref d-flex align-items-center">
                <img :src="url('/media/icons/svg/login.svg')" alt="login"/>
                <span class="str-helper">{{ trans.get('public.menu.log-in') }}</span>
              </div>
            </a>
          </div>
        </div>
      </div>
      <!-- menu-nav  -->

      <transition name="submenu">
        <div v-show="float_name === 'submenu'" class="menu-nav-float">
          <div class="">
            <div class="menu-nav-float-wrapper">
              <ul>
                <li @mouseover="articleDrop(-1)" class="login-mobile">
                  <div class="d-flex align-items-center is-justify-content-space-between">
                    <div v-if="user.loaded" class="menu-login-ref d-flex align-items-center">
                      <a class="size-09 pointer red d-flex align-items-center" @click="logout()">
                        <img src="/media/icons/svg/logout-red.svg" alt="logout" />
                        <span class="ml-4 text red">{{ trans.get('public.menu.log-out') }}</span>
                      </a>
                    </div>

                    <div v-else class="menu-login-ref">
                      <a @click="login = !login">
                        <div class="login-ref d-flex align-items-center">
                          <img
                              :src="url('/media/icons/icons8-login-50.png')"
                              alt="login"
                          />
                          <span class="str-helper text-green"
                          >{{ trans.get('public.menu.log-in') }}</span
                          >
                        </div>
                      </a>
                    </div>
                    <div class="mobile-ricerca" @click="ricerca = !ricerca">
                      <img src="/storage/media/icons/svg/icona-lente.svg" alt="search">
                      <span>{{ trans.get('public.menu.search') }}</span>
                    </div>
                  </div>
                </li>
                <li :class="(macroChosen === 'lang')? 'macro lang active': 'macro lang'">
                  <a class="my-caps" @click="articleDropC('lang')">
                    <span class="currentLang">{{ currLang }}</span>
                    <img class="pointer"
                         :src="url('/media/icons/svg/arrow-right_white.svg')"
                         alt="arrow"/>
                  </a>
                </li>
                <li
                    v-for="(macro, i) in tree"
                    :key="i"
                    class="macro"
                    :class="{ active: macroChosen === i }" @mouseover="articleDrop(i)" @click="articleDropC(i)">
                  <p v-if="i === 2 " @mouseover="articleDrop(-1)" class="sep"></p>
                  <a @click="articleDropC(i)" @mouseover="articleDrop(i)"
                     v-if="['CIN', 'NAS'].indexOf(macro.codice) > -1"
                     class="my-caps">

                    <span @mouseover="articleDrop(i)" @click="articleDropC(i)"
                          v-if="macro.codice === 'CIN' || macro.codice === 'NAS'">
                      {{ macro.descrizione }}
                    </span>

                    <img v-if="macro.codice !== 'sep'" class="pointer" @mouseover="articleDrop(i)"
                         :src="url('/media/icons/svg/arrow-right_white.svg')"
                         alt="arrow"/>
                  </a>

                  <a class="my-caps" @mouseover="articleDrop(-1)" v-if="macro.codice === 'ENG'" href="/4-engeneering">
                    <span class="caps4t">4-Engineering</span>
                  </a>
                  <a href="/catalog/4TOOLS/family/4TOOLS" class="my-caps" v-if="macro.codice === '4TOOLS'">
                    <span class="caps4t">4-Tools</span>

                  </a>
                  <a href="/catalog/4CLEAN/family/4CLEAN" class="my-caps" v-if="macro.codice === '4CLEAN'">
                    <span class="caps4t">4-Clean</span>

                  </a>


                </li>
                <li class="macro">
                  <a class="my-caps" @mouseover="articleDrop(-1)" href="/4-custom">
                    <span class="caps4t">4-Custom</span>

                  </a>
                </li>
                <!--                <li class="macro" @mouseover="articleDrop('x')" @click="articleDropC('x')"-->
                <!--                    @mouseleave="articleDrop(-1)">-->
                <!--                  <a class="my-caps">-->
                <!--                    <span class="caps4t">4-Clean</span>-->
                <!--                    <img class="pointer"-->
                <!--                         :src="url('/media/icons/svg/arrow-right_white.svg')"-->
                <!--                         alt="arrow"/>-->
                <!--                  </a>-->

                <!--                </li>-->
                <!--                <li class="macro" @mouseleave="articleDrop(-1)">-->
                <!--                  <a href="/4-engeneering">-->
                <!--                    4-Engineering-->
                <!--                    &lt;!&ndash;                    <img class="pointer"&ndash;&gt;-->
                <!--                    &lt;!&ndash;                         :src="url('/media/icons/svg/arrow-right_white.svg')"&ndash;&gt;-->
                <!--                    &lt;!&ndash;                         alt="arrow"/>&ndash;&gt;-->
                <!--                  </a>-->

                <!--                </li>-->

                <!--                <li class="macro" @mouseleave="articleDrop(-1)">-->
                <!--                  <a href="/4-custom">-->
                <!--                    4-Custom-->
                <!--                    &lt;!&ndash;                    <img class="pointer"&ndash;&gt;-->
                <!--                    &lt;!&ndash;                         :src="url('/media/icons/svg/arrow-right_white.svg')"&ndash;&gt;-->
                <!--                    &lt;!&ndash;                         alt="arrow"/>&ndash;&gt;-->
                <!--                  </a>-->

                <!--                </li>-->

                <li class="macro my-mt-4"><a class="my-caps is-capitalized" href="/about-us"
                                             @mouseleave="articleDrop(-1)">{{ trans.get('public.menu.about-us') }}</a>
                </li>
                <li class="macro text-green"><a class="my-caps is-capitalized" href="/downloads"
                                                @mouseleave="articleDrop(-1)">{{
                    trans.get('public.menu.downloads')
                  }}</a></li>

              </ul>
            </div>
          </div>
          <div v-if="macroChosen === 'lang'" class="menu-nav-float families">
            <div class="float-block product">
              <ul class="sottomenu d-flex flex-column">
                <li class="back-mobile-btn">
                  <span @click="articleDropC(-1)"><img :src="url('/storage/media/icons/svg/caret-left-green.svg')"
                                                       alt=""> {{ trans.get('public.menu.back') }}</span>
                </li>
                <li class="fam pointer lang">
                  <a href="" class="my-caps currentLang">
                    <lang-selector-new/>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div v-if="macroChosen === 'x'" class="menu-nav-float families">
            <div class="float-block product">
              <ul class="sottomenu d-flex flex-column">
                <li class="back-mobile-btn">
                  <span @click="articleDropC(-1)"><img :src="url('/storage/media/icons/svg/caret-left-green.svg')"
                                                       alt="">{{ trans.get('public.menu.back') }}</span>
                </li>
                <li class="fam pointer">
                  <a class="my-caps">
                    <span>{{ trans.get('public.menu.not-found') }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div v-if="macroChosen >= 0" class="menu-nav-float families">
            <div class="float-block product">
              <ul class="sottomenu d-flex flex-column">
                <li class="fam back-mobile-btn">
                  <span @click="articleDropC(-1)"><img :src="url('/storage/media/icons/svg/caret-left-green.svg')"
                                                       alt="">{{ trans.get('public.menu.back') }}</span>
                </li>
                <li @click="articleDrop(-1)" class="fam pointer">
                  <a
                      class="my-caps"
                      v-if="tree[macroChosen].codice !== '4TOOLS'"
                      :href="url('/catalog/' + tree[macroChosen].codice)">
                    <span>{{ tree[macroChosen].descrizione }}</span>
                  </a>
                  <a class="my-caps" v-if="tree[macroChosen].codice === '4TOOLS'">
                    <span>{{ trans.get('public.menu.not-found') }}</span>
                  </a>

                </li>
                <li
                    @click="articleDrop(-1)"
                    class="
                    d-flex
                    align-items-center
                    justify-content-between
                    fam
                    pointer
                  "
                    v-for="(famiglia, i) in tree[macroChosen].family"
                    :key="i">
                  <!--                    v-if="-->
                  <!--                    (famiglia.categorie && famiglia.categorie.length > 0) ||-->
                  <!--                    (famiglia.microfamiglie &&-->
                  <!--                      famiglia.microfamiglie.length > 0)-->
                  <!--                  "-->
                  <a v-if="famiglia.codice !== 'CUS' && famiglia.codice !== 'POL'"
                      :href="
                      url(
                        '/catalog/' +
                          tree[macroChosen].codice +
                          '/family/' +
                          famiglia.codice
                      )
                    "
                      class="
                      my-caps
                      d-flex
                      align-items-center
                      justify-content-between
                      flex-nowrap
                    "
                  >
                    <div class="sx">
                      <img
                          class="icon mr-2"
                          :src="
                          '/media/icons/svg/family/green/' +
                          famiglia.codice.toLowerCase().replace('+', 'plus') +
                          '.svg'
                            ? '/media/icons/svg/family/green/' +
                              famiglia.codice.toLowerCase().replace('+', 'plus') +
                              '.svg'
                            : 'https://via.placeholder.com/300.png'
                        "
                          alt=""
                      />

                      <span class="my-caps">{{ famiglia.descrizione }}</span>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </transition>

      <div v-show="login" class="">
        <span @click="login = !login" class="close_login"
        ><i class="fas fa-times"></i
        ></span>
        <smart_login/>
      </div>
      <div v-show="ricerca" class="">
        <span @click="ricerca = !ricerca" class="close_login">
          <i class="fas fa-times"></i>
        </span>
        <ricerca @close="ricerca = false"/>
      </div>

      <!-- nenu-nav-float -->
    </div>
    <!--  menu-content-->
  </div>
  <!-- app_menu -->
</template>

<script>
import smart_login from "./smart-login";
import universal_filter from "../reserved/universal-filter";
import ricerca from "./ricerca"

export default {
  components: {
    smart_login,
    universal_filter,
    ricerca
  },

  data: function () {
    return {
      opened_menu_nav: false,
      float_name: "",
      login: false,
      ricerca: false,
      user: {},
      langOpen: false,
      tree: null,
      macroChosen: -1,
      currLang: null,
    };
  },
  mounted() {
    this.getMenuVetrina()
    this.$store.dispatch("getUserName");
    this.$store.watch(
        (state) => state.user.loaded,
        (value) => {
          if (value) {
            this.user = this.$store.state.user;
          }
        }
    );
    this.currentLang();
  },

  methods: {
    getMenuVetrina() {
      axios({
        method: 'get',
        url: window.location.origin + '/data/menuVetrina',
      }).then(res => {
        //console.log(res.data.menu)
        this.tree = res.data.menu
      })
    },
    currentLang() {
      let current = this.$store.state.current_lang
      let languages = this.$store.state.languages
      languages.forEach((lang) => {
        if (lang.value === current) {

          this.currLang = lang.label
        }
      })
    },
    articleDropC: function (macroIndice) {
      //console.log('cl', macroIndice);
      if (window.innerWidth <= 900) {
        if (this.macroChosen === macroIndice) {
          //this.macroChosen = -1;
        } else if (macroIndice === 'x') {
          this.macroChosen = 'x'
        } else if (macroIndice === 'lang') {
          this.macroChosen = 'lang'
        } else {

          this.macroChosen = macroIndice;
        }
      } else if (window.innerWidth > 900) {
        window.location.href = window.location.origin + '/catalog/' + this.tree[macroIndice].codice

      }


      // console.log(this.macroChosen);
    },
    articleDrop: function (macroIndice) {
      //console.log('hover', macroIndice);
      if (window.innerWidth > 900) {
        if (macroIndice < 2) {
          if (this.macroChosen === macroIndice) {
            this.macroChosen = -1;
          } else if (macroIndice === 'x') {
            this.macroChosen = 'x'
          } else {

            this.macroChosen = macroIndice;
          }
        }
      }

      // console.log(this.macroChosen);
    },

    treeLoad: function (tree) {
      this.tree = tree
      // setTimeout(()=> {
      //   this.tree = _.orderBy(this.tree, 'ordinamento', 'asc')
      // }, 3000)
    },

    logout: function () {
      var vue = this;

      axios({
        method: "get",
        url: window.location.origin + "/data/logout",
      })
          .then((res) => {
            if (res.data.url) {
              window.location.href = res.data.url;
            }
          })
          .catch((err) => {
            vue.$store.commit("add_message", {
              type: "error",
              message: err.response.data.message,
            });
          })
          .then(() => {
          });
    },

    setFpNav: function () {
      let fpNav = document.getElementById("fp-nav");
      if (fpNav) {
        if (this.opened_menu_nav) {
          fpNav.classList.add("hide");
        } else {
          fpNav.classList.remove("hide");
        }
      }
    },

    // onClickMenuNav: function (name) {
    //   this.opened_menu_nav = !this.opened_menu_nav;
    //   this.setFpNav();
    // },
    onClickMenuNav: function (name) {
      if (name && name !== this.float_name) {
        this.opened_menu_nav = true;
        this.float_name = name;
      } else {
        this.opened_menu_nav = false;
        this.float_name = "";
        this.articleDrop(-1);
      }
    },

    isActiveMenu: function (name = "") {
      // console.log(name);
      return this.float_name === name;
    },

    onClickOutMenu: function (event) {
      //console.log(event.target.classList);

      if (event.target.classList.contains("menu-content")) {
        this.opened_menu_nav = false;
        this.setFpNav();
        let login;
        login = false;
        // this.float_name = "";
      }
    },
  },
};
</script>

<style scoped lang="scss">
$menu-width: 250px;
$submenu-width: 500px;
#app_menu.public {
  font-size: 1rem;
  @media (min-width: 1921px) {
    font-size: var(--font-size-large);
  }

  .ricerca {
    img {
      cursor: pointer;
      height: 20px;
    }
  }
}

.submenu-enter,
.submenu-leave-to {
  opacity: 0;
  max-width: 0;
}

.submenu-enter-to,
.submenu-leave {
  opacity: 1;
  max-width: $submenu-width;
}

.submenu-enter-active,
.submenu-leave-active {
  transition: all 0.3s linear;
}

.menu-nav-float {
  background-color: rgb(59, 59, 67);
  position: fixed;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding-top: 150px;
  z-index: 1;
  overflow-x: hidden;
  left: 0;
  top: 0;
  width: 50%; // width: 100%;
  height: calc(100% - var(--public-menu-heigth-responsive));
  overflow-y: hidden;
  @media (max-width: 900px) {
    width: 100%;
    padding-top: 15px;
    top: 50px;
  }

  .mobile-lang {
    display: none;
    @media (max-width: 576px) {
      display: flex;
      padding-left: 70px;
      margin-bottom: 20px;
    }
  }

  ul li {
    margin-bottom: unset;
    //padding: 20px 70px;

    //&:hover {
    //  background-color: #494953;
    //}

  }

  .macro {
    p.sep {
      height: 40px;
      width: 100%;
      cursor: default;

      &:hover {
        background-color: #3B3B43;
      }
    }

    .my-caps {

      &:hover {
        background-color: #494953;
      }
    }
  }

  .macro.active {
    background-color: #494953;
  }

  .macro.lang {
    @media (min-width: 1200px) {
      display: none;
    }
  }

}

#app_menu.public .menu-nav-float ul li a {
  padding: 20px 20px 20px 40px;
  font-weight: 300;
}

.families {
  background-color: #494953 !important;

  ul li.fam {
    color: #fff;

    &:hover {
      background-color: #5f5f6e;
    }
  }

  ul li.back-mobile-btn {
    font-weight: 300;
    padding-left: 20px;
    padding-bottom: 30px;
    color: var(--greenb2b) !important;

    img {
      height: 12px;
      display: inline-block;
      margin-right: 3px;
    }

    @media (min-width: 900px) {
      display: none;
    }
  }
}

#app_menu.public {
  height: var(--public-menu-heigth-responsive);
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: transparent;
  color: white;
  z-index: 10;

}

/*  Elemento a cui applichiamo l'effeto blur  */
#app_menu.public.active {
  width: 100vw;
}

#app_menu.public.active .menu-effect {
  width: 100vw;
  height: 100vh;
}

a:hover {
  color: inherit !important;
}

#app_menu.public .menu-effect {
  position: absolute;
  z-index: 0;
  transition: 0.3s width ease-in;
  width: 100%;
  height: 100%;
}

.menu-search {
  opacity: 0;
  z-index: -1;
}

.contact-ref {
  display: flex;
  align-items: center;
  cursor: pointer;
  letter-spacing: 1px;
}

.contact-ref img {
  display: block;
  width: 30px;
  margin-right: 0;
}

.login-ref {
  cursor: pointer;
  letter-spacing: 1px;

  img {
    display: block;
    width: 40px;
    margin-right: 30px;
    color: #fff;

    &:hover {
      color: #fff;
    }
  }
}

.contact-ref img {
  width: 26px;
  margin-right: 0;
}

.mob-none {
  display: none;
}

.menu-nav-float-wrapper a.row::after {
  display: none !important;
}

.login-mobile:hover {
  background-color: #494953;
}
.login-mobile {
  .menu-login-ref {
    width: 50%;
  }
  .mobile-ricerca {
    display: none;
    width: 50%;
    justify-content: flex-end;
    padding-right: 40px;
    @media (max-width: 576px){
      display: flex;
    }
    img {
      height: 20px;
    }
    span {
      margin-left: 20px;
    }
  }
}

#app_menu
> div.menu-content
> div.menu-nav
> div.user-menu
> div.menu-login-ref.d-flex.align-items-center {
  width: 50%;
  justify-content: space-around;
}

#app_menu
> div.menu-content
> div.menu-nav
> div.user-menu
> div.menu-login-ref.d-flex.align-items-center
> div {
  justify-content: space-around;
  width: 50%;
}

.close_login {
  position: fixed;
  right: 2rem;
  top: 2rem;
  z-index: 11;
  @media (max-width: 576px){
    top: 1rem;
  }
}

@media (min-width: 576px) {
  .mob-none {
    display: inline;
  }
  #app_menu
  > div.menu-content
  > div.menu-nav
  > div.user-menu
  > div.menu-login-ref.d-flex.align-items-center {
    width: unset;
    justify-content: unset;
  }
  #app_menu
  > div.menu-content
  > div.menu-nav
  > div.user-menu
  > div.menu-login-ref.d-flex.align-items-center
  > div {
    width: unset;
    justify-content: unset;
  }
}

@media (min-width: 1200px) {
  .user-menu {
    display: block;
    margin-top: 2rem;
    position: fixed;
    left: 0;
    top: 50px;
    width: 100vw;
    justify-content: space-around;

  }
}

@media (max-width: 900px) {
  #app_menu.public .menu-nav-float {
    .families {
      left: 0;
      width: 100%;
    }
  }
}

@media (min-width: 1200px) {
  .user-menu {
    margin-top: 0;
    display: flex;
    align-items: center;
    position: fixed;
    left: unset;
    right: 20px;
    top: 20px;
    justify-content: space-around;
    width: 40%;

    &.unlogged {
      width: 25%;
    }
  }

  #app_menu.public .menu-effect {
    width: 250px;
    height: 100%;
  }
  #app_menu.public.active .menu-effect {
    width: 100%;
  }
  .menu-nav-float {
    height: 100%;
    width: $submenu-width;
    left: $menu-width;

    .families {
      left: $submenu-width + $menu-width;
      background-color: #494953;
      color: #fff;

    }
  }

  .contact-ref .str-helper {
    display: flex;
  }

  .contact-ref img {
    margin-right: 20px;
  }
  #app_menu.public {
    width: auto;
    height: 100vh;
  }
}

.my-caps p.sep {
  padding: 20px 50px;
}

.my-caps span {
  display: inline-block;
  font-weight: 300;
  width: 100%;

  &.currentLang {
    text-transform: uppercase;

  }

  &.caps4t {
    text-transform: none;
  }

  &:first-letter {
    text-transform: uppercase;
  }
}
@media all and (max-height: 720px) {
  .menu-nav-float {
    padding-top: 0;
    .macro {
      p.sep {
        height: 20px;
      }
    }
  }
  #app_menu.public .menu-nav-float ul li.macro.my-mt-4 {
    margin-top: 2rem;
  }
}
@media (max-width: 1200px) {
  .user-menu {
    display: none;
  }
}

@media (min-width: 1921px) {
  .wrap-logo {
    img {
      width: 200px;
    }
  }

}
</style>
